import { render, staticRenderFns } from "./UploadFilesComponent.vue?vue&type=template&id=4df43c53&scoped=true&"
import script from "./UploadFilesComponent.vue?vue&type=script&lang=ts&"
export * from "./UploadFilesComponent.vue?vue&type=script&lang=ts&"
import style0 from "./UploadFilesComponent.vue?vue&type=style&index=0&id=4df43c53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df43c53",
  null
  
)

component.options.__file = "UploadFilesComponent.vue"
export default component.exports